module.exports = __webpack_public_path__ + "img/3771500.png";